/**
 * Hook into Alpine so that it is available no matter at which point Alpine loads.
 */
document.addEventListener('alpine:init', () => {
    /**
     * Manages the current toggle and date fields on service forms.
     *
     * @param string currentName  the name of the current toggle in the form
     * @param string endDateName  the name of the end date input in the form
     * @param string endDateValue wired value from the backend for the end date input
     */
    Alpine.data('current', (currentName, endDateName, endDateValue) => ({
        /**
         * @var string the name of the current toggle in the form
         */
        currentName: currentName,

        /**
         * @var string the name of the end date input in the form
         */
        endDateName: endDateName,

        /**
         * @var element the current toggle element in the form
         */
        currentToggle: null,

        /**
         * @var element the end date input element in the form
         */
        endDateInput: null,

        /**
         * @var string wired value from the backend for the end date input
         */
        endDateValue: endDateValue,

        /**
         * Run on intialization of the alpine data.
         *
         * @return void
         */
        init() {
            this.currentToggle = this.$el.querySelector('[name='+this.currentName+']');
            this.endDateInput  = this.$el.querySelector('[name='+this.endDateName+']');
            this.$el.addEventListener('input-changed-current', this.updateEndDateByEvent.bind(this));
            this.$watch('endDateValue', () => this.updateCurrent());
            this.updateCurrent();
        },

        /**
         * Update the current toggle based on the value of the end date input.
         *
         * @return void
         */
        updateCurrent() {
            this.currentToggle.checked = constants.current_dates.includes(this.endDateValue?.toLowerCase())
            if (this.currentToggle.checked) {
                this.updateEndDate(this.makeCurrentDateString(), true);
            }
        },

        /**
         * Update the end date based on the value of the current toggle.
         *
         * @param {object} $event event that was dispatched when current was toggled
         *
         * @return void
         */
        updateEndDateByEvent($event) {
            let value = '';
            if ($event.detail) {
                value = this.makeCurrentDateString();
            }
            this.updateEndDate(value, $event.detail);
        },

        /**
         * Update the end date.
         *
         * @param {String} endDateValue
         * @param {Boolean} readOnly
         */
        updateEndDate(endDateValue, readOnly = false) {
            this.endDateValue          = endDateValue;
            this.endDateInput.value    = endDateValue;
            this.endDateInput.readOnly = readOnly;
        },

        /**
         * Make "current date" string based on constant.
         *
         * @return {string}
         */
        makeCurrentDateString()
        {
            const value = String(constants.current_date);

            return value.charAt(0).toUpperCase() + value.slice(1);
        },

        /**
         * Alpine bindings for the end date input field.
         *
         * @return object
         */
        endDateBindings: {
            ':readOnly'() {
                return this.currentToggle.checked
                    || this.endDateInput.disabled
                    || this.endDateInput.value === constants.current_date;
            },
        },
    }));
});
